import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../shared/utils/request";
import DeleteAccountConfirmation from "./DeleteAccountConfirmation";
import "./SettingsModal.css";

const SettingsModal = ({ isOpen, onClose, onLogout }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleDeleteAccount = async () => {
    setDeleting(true);
    setError(null);
    try {
      await api.delete("customer/delete-account");
      localStorage.clear();
      onClose();
      window.location.href = "/";
    } catch (err) {
      setError(err?.message || "Failed to delete account. Please try again.");
      setDeleting(false);
    }
  };

  return (
    <>
      <div className="settings-modal-overlay" onClick={onClose}>
        <div
          className="settings-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="settings-modal-close"
            aria-label="Close settings"
            onClick={onClose}
          >
            <i className="ph ph-x" />
          </button>
          <div className="settings-modal-icon">
            <i className="ph ph-gear-six" />
          </div>
          <h3 className="settings-modal-title">Settings</h3>
          <p className="settings-modal-text">
            Manage your account preferences.
          </p>
          <div className="settings-modal-actions">
            <button
              type="button"
              className="settings-modal-btn settings-modal-btn-delete"
              onClick={() => setShowDeleteConfirm(true)}
            >
              <i className="ph ph-trash" aria-hidden="true" />
              Delete Account
            </button>
            <button
              type="button"
              className="settings-modal-btn settings-modal-btn-logout"
              onClick={onLogout}
            >
              <i className="ph ph-sign-out" aria-hidden="true" />
              Logout
            </button>
          </div>
        </div>
      </div>
      <DeleteAccountConfirmation
        isOpen={showDeleteConfirm}
        deleting={deleting}
        error={error}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={handleDeleteAccount}
      />
    </>
  );
};

export default SettingsModal;